import EventBus from '@/eventBus'

export const REPORT_UPGRADE_REQUEST_EVENT = 'reportUpgradeRequested'

export const requestReportUpgrade = (anchor = null) => EventBus.$emit(REPORT_UPGRADE_REQUEST_EVENT, anchor)
